export const getChatConversation = (id) => (state) => state.chat.conversations.entries?.[id] || null;
